<template>
  <b-modal
    id="my-add-action-popup"
    centered
    hide-footer
    hide-header
    body-class="my-add-action-popup"
    dialog-class="dialog-my-add-action-popup"
    @hidden="isHide"
  >
    <button
      @click="hideModal"
      class="tw-absolute tw-top-[20px] tw-right-[20px] tw-grid tw-place-items-center tw-w-[40px] tw-h-[40px] tw-border-[1px] tw-border-transparent tw-text-[#d9d9d9] hover:tw-text-[var(--my-text-color)] tw-transition-colors"
    >
      <icon-close />
    </button>

    <div
      class="tw-absolute tw-top-[14px] tw-left-[50%] tw-translate-x-[-50%] tw-block md:tw-hidden tw-w-[74px] tw-h-[2px] tw-bg-[#E1E1E1]"
    ></div>

    <h3 class="tw-text-center tw-text-[25px] tw-font-black tw-mb-[34px]">
      {{ $t("donor_dashboard.my_contacts_popup_title_add_an_action", "Add an Action") }}
    </h3>
    <div v-if="error" class="tw-text-red-500 tw-mb-2">{{ error }}</div>
    <div v-if="success" class="tw-text-green-500 tw-mb-2">
      {{ $t("donor_dashboard.my_contacts_action_added_success", "Action added successfully!") }}
    </div>

    <div class="tw-flex tw-flex-wrap tw-gap-[10px] tw-gap-y-[15px]">
      <my-btn btnStyle="my-default-toggleable" v-model="btnModels[ACTION_KEYS.ActionTypePhoneCall]">
        {{ $t("donor_dashboard.my_contacts_btn_phone_call", "Phone Call") }}
      </my-btn>
      <my-btn
        btnStyle="my-default-toggleable"
        v-model="btnModels[ACTION_KEYS.ActionTypeLeftVoiceMsg]"
      >
        {{ $t("donor_dashboard.my_contacts_btn_left_voice_message", "Left Voice Message") }}
      </my-btn>
      <my-btn
        btnStyle="my-default-toggleable"
        v-model="btnModels[ACTION_KEYS.ActionTypeSentWhatsApp]"
      >
        {{ $t("donor_dashboard.my_contacts_btn_sent_whatsapp", "Sent Whatsapp") }}
      </my-btn>
      <my-btn btnStyle="my-default-toggleable" v-model="btnModels[ACTION_KEYS.ActionTypeSentEmail]">
        {{ $t("donor_dashboard.my_contacts_btn_sent_an_email", "Sent an Email") }}
      </my-btn>
      <my-btn
        btnStyle="my-default-toggleable"
        v-model="btnModels[ACTION_KEYS.ActionTypePersonalMeeting]"
      >
        {{ $t("donor_dashboard.my_contacts_btn_personal_meeting", "Personal Meeting") }}
      </my-btn>
      <my-btn btnStyle="my-default-toggleable" v-model="btnModels[ACTION_KEYS.ActionTypeVideoCall]">
        {{ $t("donor_dashboard.my_contacts_btn_video_call_zoom", "Video Call/Zoom") }}
      </my-btn>
      <my-btn
        btnStyle="my-default-toggleable"
        v-model="btnModels[ACTION_KEYS.ActionTypeSentInformation]"
      >
        {{ $t("donor_dashboard.my_contacts_btn_sent_information", "Sent information") }}
      </my-btn>
      <my-btn
        btnStyle="my-default-toggleable"
        v-model="btnModels[ACTION_KEYS.ActionTypeRequestCallBack]"
      >
        {{ $t("donor_dashboard.my_contacts_btn_requested_a_call_back", "Requested a call back") }}
      </my-btn>
    </div>

    <div class="tw-mt-[32px]" v-if="btnModels[ACTION_KEYS.ActionTypeRequestCallBack]">
      <p class="tw-mb-[15px] tw-text-[#170F49] tw-text-[15px] tw-font-medium">
        {{
          $t(
            "donor_dashboard.my_contacts_actions_notes_choose_callback_date",
            "Choose a call back date"
          )
        }}
      </p>
      <div
        @click="triggerInput"
        class="tw-relative tw-flex tw-items-center tw-gap-[20px] tw-w-full tw-px-[20px] tw-py-[7px] tw-rounded-full tw-bg-[var(--my-white-soft)]"
      >
        <icon-date-picker />
        <div class="tw-flex tw-items-center tw-justify-between tw-grow">
          <span class="tw-grow tw-text-center tw-text-[13px] tw-text-[var(--my-primary)]">{{
            formattedDate
          }}</span>
          <div class="tw-w-[1px] tw-h-[20px] tw-bg-[#C4C4C4]"></div>
          <span class="tw-grow tw-text-center tw-text-[13px] tw-text-[var(--my-primary)]">{{
            formattedTime
          }}</span>
        </div>
        <input
          ref="hiddenInput"
          type="datetime-local"
          v-model="dateTime"
          class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-opacity-0 tw-cursor-pointer"
        />
      </div>
      <p class="tw-hidden tw-mb-0 tw-mt-[14px] tw-text-[12px] tw-italic">
        <!-- TODO: tbd -->
        {{
          $t(
            "donor_dashboard.my_contacts_actions_your_timezone_is_set",
            "Your timezone is set to New York,"
          )
        }}
        <a class="tw-text-[inherit] tw-underline" href="#">{{
          $t("donor_dashboard.my_contacts_actions_click_here", "click here")
        }}</a>
        {{ $t("donor_dashboard.my_contacts_actions_to_change_it", "to change it.") }}
      </p>
    </div>

    <my-textarea v-model="form.notes" class="tw-mt-[32px]">
      <template v-slot:label>
        <span class="tw-flex tw-mb-[15px] tw-text-[16px] tw-tracking-[0.01em]">
          {{ $t("donor_dashboard.my_contacts_notes_title", "Notes") }}
        </span>
      </template>
    </my-textarea>

    <div
      class="tw-flex tw-flex-wrap tw-justify-between tw-gap-[10px] tw-mt-[34px] tw-opacity-30 tw-pointer-events-none"
      :style="hasAnyBtnModelTrue ? { opacity: '1', 'pointer-events': 'all' } : {}"
    >
      <my-btn btnStyle="my-outlined" @click="hideModal">
        {{ $t("donor_dashboard.my_contacts_btn_add_action_cancel", "Cancel") }}
      </my-btn>
      <my-btn btnStyle="my-primary" :loading="loading" @click="submitAction">
        {{ $t("donor_dashboard.my_contacts_btn_add_action_submit", "Sumbit") }}
      </my-btn>
    </div>
  </b-modal>
</template>

<script>
import iconClose from "@/views/donor-dashboard/my-contacts/icons/close.vue";
import myTextarea from "@/views/donor-dashboard/my-contacts/ui/my-textarea.vue";
import myBtn from "@/views/donor-dashboard/my-contacts/ui/my-btn.vue";
import iconDatePicker from "@/views/donor-dashboard/my-contacts/icons/date-picker.vue";
import { useTeamLeaderContactActions } from "@/composables/useDashboardTeamLeaderContactActions";
import { ACTION_KEYS } from "../constants";

export default {
  data() {
    return {
      ACTION_KEYS,

      dateTime: "",
      btnModels: {
        [ACTION_KEYS.ActionTypePhoneCall]: false,
        [ACTION_KEYS.ActionTypeLeftVoiceMsg]: false,
        [ACTION_KEYS.ActionTypeSentWhatsApp]: false,
        [ACTION_KEYS.ActionTypeSentEmail]: false,
        [ACTION_KEYS.ActionTypePersonalMeeting]: false,
        [ACTION_KEYS.ActionTypeVideoCall]: false,
        [ACTION_KEYS.ActionTypeSentInformation]: false,
        [ACTION_KEYS.ActionTypeRequestCallBack]: false,
      },
      form: {
        notes: "",
      },
      contactId: null,
      loading: false,
      error: null,
      success: false,
    };
  },

  setup() {
    const teamLeaderContactActions = useTeamLeaderContactActions();

    return {
      teamLeaderContactActions,
    };
  },

  computed: {
    hasAnyBtnModelTrue() {
      return Object.values(this.btnModels).some((value) => value === true);
    },

    formattedDate() {
      const value = this.dateTime || new Date().toISOString();
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(value).toLocaleDateString("en-US", options);
    },

    formattedTime() {
      const value = this.dateTime || new Date().toISOString();
      const options = { hour: "numeric", minute: "2-digit", hour12: true };
      return new Date(value).toLocaleTimeString("en-US", options);
    },
  },

  mounted() {
    this.$root.$on("my-add-action-popup-data", this.setModalData);
  },

  beforeDestroy() {
    this.$root.$off("my-add-action-popup-data", this.setModalData);
  },

  methods: {
    triggerInput() {
      this.$refs.hiddenInput?.showPicker();
    },

    isHide() {
      this.resetForm();
    },

    setModalData(payload) {
      if (payload.data) {
        this.contactId = payload.data.id;
      }
    },

    openModal() {
      this.$root.$emit("bv::show::modal", "my-add-action-popup");
    },

    hideModal() {
      this.$root.$emit("bv::hide::modal", "my-add-action-popup");
    },

    resetForm() {
      this.btnModels = {
        [ACTION_KEYS.ActionTypePhoneCall]: false,
        [ACTION_KEYS.ActionTypeLeftVoiceMsg]: false,
        [ACTION_KEYS.ActionTypeSentWhatsApp]: false,
        [ACTION_KEYS.ActionTypeSentEmail]: false,
        [ACTION_KEYS.ActionTypePersonalMeeting]: false,
        [ACTION_KEYS.ActionTypeVideoCall]: false,
        [ACTION_KEYS.ActionTypeSentInformation]: false,
        [ACTION_KEYS.ActionTypeRequestCallBack]: false,
      };
      this.form.notes = "";
      this.dateTime = "";
      this.loading = false;
      this.error = null;
      this.success = false;
    },

    async submitAction() {
      this.loading = true;
      this.error = null;
      try {
        // Collect selected action types
        const actionTypes = Object.keys(this.btnModels).filter((k) => this.btnModels[k]);
        if (actionTypes.length === 0) {
          this.error = this.$t(
            "donor_dashboard.my_contacts_error_select_action_type",
            "Please select at least one action type."
          );
          this.loading = false;
          return;
        }

        // Format follow_up_date if needed
        const followUpDate = this.btnModels[ACTION_KEYS.ActionTypeRequestCallBack]
          ? new Date(this.dateTime).toISOString()
          : null;

        await Promise.all(
          actionTypes.map((type) =>
            this.teamLeaderContactActions.createContactAction(this.contactId, {
              type,
              follow_up_date: followUpDate,
              note: this.form.notes,
            })
          )
        );
        await this.teamLeaderContactActions.fetchContactActions(this.contactId);

        this.success = true;
        this.hideModal();
      } catch (err) {
        this.error =
          err.message ||
          this.$t("donor_dashboard.my_contacts_error_failed_add_action", "Failed to add action.");
      } finally {
        this.loading = false;
      }
    },
  },

  components: {
    iconClose,
    myTextarea,
    myBtn,
    iconDatePicker,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog.dialog-my-add-action-popup {
  @apply tw-items-end md:tw-items-center tw-w-full md:tw-w-[434px] tw-min-h-[100dvh] md:tw-min-h-[calc(100%-3.5rem)] tw-mx-auto tw-my-0 md:tw-my-[1.75rem];
}

::v-deep .dialog-my-add-action-popup .modal-content {
  @apply tw-rounded-t-[20px] md:tw-rounded-none tw-shadow-[0px_2px_20px_rgba(0,0,0,0.25)];
}

::v-deep .dialog-my-add-action-popup .my-add-action-popup {
  @apply tw-pt-[40px] tw-px-[54px] tw-pb-[64px] tw-rounded-t-[20px] md:tw-rounded-none tw-font-lato tw-text-[var(--my-text-color)] tw-leading-[var(--my-leading)] tw-bg-[var(--my-search-bg-md)];
}
</style>
